<template>
  <div id="homepage">
    <!-- Header-->
        <header class="bg-dark py-5">
            <div class="container px-4 px-lg-5 my-5">
                <div class="text-center text-white">
                    <h1 class="display-4 fw-bolder">Word puzzles</h1>
                    <p class="lead fw-normal text-white-50 mb-0">Entertainment for the whole family!</p>
                </div>
            </div>
        </header>
        <!-- Section-->
        <section class="py-5">
            <div class="container px-4 px-lg-5 mt-5">
                <div class="row gx-4 gx-lg-5 row-cols-2 row-cols-md-3 row-cols-xl-4 justify-content-center">
                    
                    <div class="col mb-5" v-for="book in books" v-bind:key="book.title">
                        <div class="card h-100" >
                            <!-- Sale badge-->
                            <div class="badge bg-dark text-white position-absolute" style="top: 0.25rem; right: 0.25rem" v-if="book.sale">Sale</div>
                            <div class="badge bg-dark text-white position-absolute" style="top: 0.25rem; right: 0.25rem" v-if="book.new">New!</div>
                            <!-- Product image-->
                            <a :href="book.href"><img class="card-img-top" :src="book.cover" :title="book.title" :alt="book.title" /></a>
                            <!-- Product details-->
                            <div class="card-body p-4">
                                <div class="text-center">
                                    <!-- Product name-->
                                    <h5 class="fw-bolder"><a :href="book.href" style="text-decoration:none; color:black">{{book.title}}</a></h5>
                                    <!-- Product reviews-->
                                    <!-- <div class="d-flex justify-content-center small text-warning mb-2">
                                        <div class="bi-star-fill"></div>
                                        <div class="bi-star-fill"></div>
                                        <div class="bi-star-fill"></div>
                                        <div class="bi-star-fill"></div>
                                        <div class="bi-star-fill"></div>
                                    </div> -->
                                    <!-- Product price-->
                                    <!-- <span class="text-muted text-decoration-line-through">$20.00</span> -->
                                    ${{book.price}}
                                </div>
                            </div>
                            <!-- Product actions-->
                            <div class="card-footer p-4 pt-0 border-top-0 bg-transparent">
                                <div class="text-center"><a class="btn btn-outline-dark mt-auto" :href="book.amazonhref" v-if="book.amazonhref">Buy on Amazon</a><span v-else>Coming Soon!</span></div>
                            </div>
                        </div>
                    </div>
                    <div class="col mb-5" v-if="latestPuzzle">
                        <div class="card h-100" >
                            <!-- Sale badge-->
                            <!-- Product image-->
                            <a :href="`/puzzles/${latestPuzzle.date}`"><img class="card-img-top" :src="`/puzzles/${latestPuzzle.date}.png`" :title="latestPuzzle.title" :alt="latestPuzzle.title" /></a>
                            <!-- Product details-->
                            <div class="card-body p-4">
                                <div class="text-center">
                                    <!-- Product name-->
                                    <h5 class="fw-bolder"><a :href="`/puzzles/${latestPuzzle.date}`" style="text-decoration:none; color:black">Today is:<br />{{latestPuzzle.title}}</a></h5>
                                    <!-- Product reviews-->
                                    <!-- <div class="d-flex justify-content-center small text-warning mb-2">
                                        <div class="bi-star-fill"></div>
                                        <div class="bi-star-fill"></div>
                                        <div class="bi-star-fill"></div>
                                        <div class="bi-star-fill"></div>
                                        <div class="bi-star-fill"></div>
                                    </div> -->
                                    <!-- Product price-->
                                    <!-- <span class="text-muted text-decoration-line-through">$20.00</span> -->
                                    
                                </div>
                            </div>
                            <!-- Product actions-->
                            
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Footer-->
  </div>
</template>

<script>

export default {
  name: 'HomePage',
  mounted() {
    this.fetchBooks();
    this.fetchDailyPuzzle();
    document.title = "Katie's Puzzles";
  },
  data() {
    return {
        books: [],
        latestPuzzle: {}
    }
  },
  methods: {
    async fetchBooks() {
        const response = await fetch("/books/index.json", { cache: "no-store" });
        const json = await response.json();

        this.books = json.books;
    },
    async fetchDailyPuzzle() {
        const response = await fetch("/puzzles/latest.json", { cache: "no-store" });
        const json = await response.json();

        this.latestPuzzle = json;
    }
  }
}
</script>

<style>

</style>
